export class MapData {
    count: number;
    lat: number;
    lon: number;
    type: string;
    variance: number;
}
